import styled from 'styled-components';

interface CardProps {
	$active?: boolean;
}

export const Quantity = styled.span`
	${({ theme }) => theme.typography.headlines.h2};
	color: ${({ theme }) => theme.colors.primary.medium};
	display: block;
	text-align: center;
`;

export const Label = styled.span`
	${({ theme }) => theme.typography.headlines.h5};
	color: ${({ theme }) => theme.colors.body.medium};
	display: block;
	text-align: center;
	transition: all ease-in-out 0.5s;
`;

export const SubLabel = styled.span`
	${({ theme }) => theme.typography.label.small};
	color: ${({ theme }) => theme.colors.neutral.red};
	display: block;
	text-align: center;
	transition: all ease-in-out 0.5s;
`;

export const DashboardCard = styled.article<CardProps>`
	${({ theme }) => theme.boxShadow.primary};
	width: 100%;
	border-radius: 20px;
	user-select: none;
	padding: 20px 5px;
	transition: transform ease-in-out 0.5s;
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border: ${({ $active, theme }) =>
		$active ? `1px solid ${theme.colors.primary.medium}` : 'none'};

	&:hover {
		transform: translateY(-8px);

		${Label} {
			color: ${({ theme }) => theme.colors.primary.medium};
		}
	}
`;

export const LogoContainer = styled.div`
	height: 100px;
	width: 156px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 8px;
`;

export const Logo = styled.img`
	height: 100%;
	width: 100%;
	object-fit: contain;
`;

export const Name = styled.span`
	${({ theme }) => theme.typography.headlines.h6};
	color: ${({ theme }) => theme.colors.body.medium};
	display: block;
	margin-bottom: 20px;
	text-align: center;
	transition: all ease-in-out 0.5s;
`;

export const Offers = styled.span`
	${({ theme }) => theme.typography.label.small};
	color: ${({ theme }) => theme.colors.body.medium};
	display: block;
	text-align: center;
	transition: all ease-in-out 0.5s;
`;

export const DealerCard = styled.article<CardProps>`
	display: flex;
	height: 100%;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	user-select: none;
	background-color: ${({ theme }) => theme.colors.background.light};
	border-radius: 12px;
	padding: 12px;
	transition: transform ease-in-out 0.5s;

	${LogoContainer} {
		margin-bottom: 12px;
	}

	${({ $active, theme }) => {
		if ($active) {
			return `
				border: 1px solid ${theme.colors.primary.medium};

				${Name} {
					color: ${theme.colors.primary.medium};
				}

				${Offers} {
					color: ${theme.colors.primary.medium};
				}
			`;
		}
	}}

	&:hover {
		transform: translateY(-8px);

		${Name} {
			color: ${({ theme }) => theme.colors.primary.medium};
		}

		${Offers} {
			color: ${({ theme }) => theme.colors.primary.medium};
		}
	}
`;
